<style lang="scss" scoped>
.msgbox {
    z-index: 2001;
    width: 6.5rem;
    border-radius: 0.2rem;
    position: fixed;
    top: 50%;
    left: 50%;
    -webkit-transform: translate3d(-50%, -50%, 0);
    transform: translate3d(-50%, -50%, 0);
    background-color: #fff;
    font-size: 0.28rem;
    -webkit-user-select: none;
    overflow: hidden;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    -webkit-transition: 0.2s;
    transition: 0.2s;
}
.v-modal {
    z-index: 2000;
}
.close {
    width: 28px;
    height: 28px;
    position: absolute;
    right: 48px;
    top: 48px;
}
.fade-enter-active,
.fade-leave-active {
    transition: all 0.2s;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
    transform: translate3d(-50%, -50%, 0) scale(0.9);
}
</style>

<template >
    <div class="pop" v-show="visible" @click="closeBg">
        <div class="v-modal" @touchmove.prevent></div>
        <transition name="fade">
            <div class="msgbox" :style="boxStyle" v-if="boxVisible" @touchmove.prevent>
                <div class="close" @click="close" v-if="visibleClose">
                    <icon name="pop-close.png" :size="28"></icon>
                </div>
                <slot name="pop" ></slot>
            </div>
        </transition>
    </div>
</template>

<script>
import icon from '@/components/Icon'

export default {
    components: { icon },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        boxStyle: {
            type: Object,
            default: () => { }
        },
        visibleClose: {
            type: Boolean,
            default: true
        },
        one: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            boxVisible: false
        }
    },
    watch: {
        visible(val) {
            this.boxVisible = val
        }
    },
    methods: {
        closeBg() {
            this.boxVisible = false
            this.$emit('isHide', this.one)
        },
        close() {
            this.boxVisible = false
            setTimeout(() => {
                this.$emit('update:visible', false)
            }, 200)
        }
    }
}
</script>
